
<template>
  <div v-if="!isCallingUsers">
    <form
      id="profile-form"
      @submit.prevent="submit"
    >
      <div>
        <user-avatar-uploader
          :profilePictureId="profilePictureId"
          :userName="fullUserName"
          @avatarChange="setAvatar"
        ></user-avatar-uploader>
      </div>

      <div class="mt-4">
        <div class="row">
          <div class="input--block col-lg-3 col-md-6 mb-3">
            <label
              for=""
              class="form--label"
            >
              {{ $t('NAME').toUpperCase() }}</label>
            <div
              class="Form-field"
              :class="{'Form--field-error' : $v.firstName.$error}"

              v-focus-input
            >
              <input
                class="Input-text"
                :disabled="userHasCards"
                v-model="$v.firstName.$model"
              />
            </div>
          </div>
          <div class="input--block col-lg-3 col-md-6 mb-3">
            <label
              for=""
              class="form--label"
            >
              {{ $t('LAST_NAME').toUpperCase() }}</label>
            <div
              class="Form-field"
              :class="{'Form--field-error' : $v.lastName.$error}"
            >
              <input
                class="Input-text"
                :disabled="userHasCards"
                v-model="$v.lastName.$model"
              />
            </div>
          </div>
          <div class="input--block col-lg-3 col-md-6 mb-3">
            <label
              for=""
              class="form--label"
            >
              {{ $t('PHONE_NUMBER').toUpperCase() }}</label>
            <div class="Form-field">
              <div class="phone-box">
                <multi-select-input
                  :disabled="isDisabled"
                  :id="'multiselect-input-prefix'"
                  :value="phonePrefix"
                  :customLabelField="'phonePrefix'"
                  :selectLabel="''"
                  :deselectLabel="''"
                  :selectedLabel="''"
                  @inputSelected="setPhonePrefix($event)"
                  @close="touchPhoneFields"
                  :placeholder="$t('PHONE_PREFIX')"
                  :options="phonePrefixList"
                ></multi-select-input>
                <input
                  class="Input-text"
                  :disabled="isDisabled"
                  @input="touchPhoneFields"
                  :placeholder="$t('PHONE_NUMBER')"
                  type="text"
                  v-model="phone"
                >
              </div>
            </div>
          </div>
          <div class="input--block col-lg-3 col-md-6 mb-3">
            <label
              for=""
              class="form--label"
            >
              {{ $t('user_profile_job_title').toUpperCase() }}</label>
            <div
              class="Form-field"
              :class="{'Form--field-error' : $v.jobTitle.$error}"
            >
              <input
                class="Input-text"
                v-model="$v.jobTitle.$model"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="input--block col-lg-4 col-md-6 mb-3">
            <label
              for=""
              class="form--label"
            >
              {{ $t('user_profile_email').toUpperCase() }}</label>
            <div
              class="Form-field"
              v-focus-input
            >
              <input
                class="Input-text"
                v-model="$v.email.$model"
                :disabled="isDisabled"
              />
            </div>
          </div>
          <div class="input--block col-lg-4 col-md-6 mb-3">
            <label
              for=""
              class="form--label"
            >
              {{ $t('PASSWORD').toUpperCase() }}</label>
            <div
              class="Form-field relative"
              v-focus-input
            >
              <input
                class="Input-text"
                value="*********"
                :disabled="true"
              />

              <button
                class="reset-secret-button"
                type="button"
                @click="showResetPasswordModal"
              >
                {{ $t('user_profile_change_password') }}
              </button>
            </div>
          </div>
          <div class="input--block col-lg-4 col-md-6 mb-3">
            <label
              for=""
              class="form--label"
            >
              {{ $t('PASSCODE').toUpperCase() }}</label>
            <div
              class="Form-field relative"
              v-focus-input
            >
              <input
                class="Input-text"
                value="****"
                :disabled="true"
              />

              <button
                class="reset-secret-button"
                type="button"
                @click="showSetPasscodeModal"
              >
                {{ $t('user_profile_change_passcode') }}
              </button>
            </div>
            <a
              href="#"
              class="d-flex justify-content-end pr-2 text-primary forgot-passcode-tag"
              @click.prevent="showRequestResetPasscodeConfirmModal"
              v-t="{path:'user_profile_form_forgot_passcode_action'}"
            ></a>
          </div>
        </div>
      </div>
      <div>
        <button
          class="Fuell-Button blue submit-button"
          :disabled="!canBeSubmitted || isSubmitting"
          form="profile-form"
          type="submit"
        ><span
            class="Button-lit"
            v-t="{path: 'ACTION_SAVE'}"
          ></span>
        </button>
        <div class="buffer"></div>
      </div>
    </form>
    <div
      class="w-100 d-flex justify-content-center"
      v-if="isRequestingResetPasscode"
    >
      <Spinner />
    </div>

    <confirm-modal
      :open.sync="showRequestResetPasscodeConfirmModalFlag"
      v-if="showRequestResetPasscodeConfirmModalFlag"
      :title="'user_profile_forgot_passcode_modal_header'"
      :dismissText="'ACTION_CANCEL'"
      :message="'user_profile_forgot_passcode_message'"
      :acceptText="'user_profile_forgot_passcode_confirm_request_reset_passcode'"
      :acceptBtnClass="'blue'"
      @accept="requestResetPasscode"
    ></confirm-modal>

  </div>
  <div
    class="w-100 d-flex justify-content-center"
    v-else
  >
    <Spinner />
  </div>
</template>

<script>

import _usersRequestResetPasscodeMixin from '../../_mixins/_usersRequestResetPasscodeMixin'

import MultiSelectInput from '@/components/Commons/Forms/MultiSelectInput'
import UserAvatarUploader from './UserAvatarUploader'
import Spinner from '@/components/Commons/Spinner'

import { segmentIdentify, segmentTrack } from '@/analytics/segment'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

const { validationMixin } = require('vuelidate')
const { required } = require('vuelidate/lib/validators')
export default {
  name: 'UserProfileForm',
  data () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phonePrefix: '',
      phone: '',
      password: '',
      jobTitle: '',
      passWordForPasscode: '',
      newPasscode: '',
      oldPasscode: '',
      showResetPasswordModalFlag: false,
      profilePictureId: 0,
      userAvatar: null,
      fakePasscode: '',
      isSubmitting: false,
      showConfirmModalFlag: false,
      isCallingUsers: false
    }
  },

  mixins: [validationMixin, _usersRequestResetPasscodeMixin],
  components: { MultiSelectInput, UserAvatarUploader, Spinner, ConfirmModal },
  methods: {
    async submit () {
      if (!this.canBeSubmitted || this.isSubmitting) return
      let updatedUser = {
        id: this.loggedUserId,
        firstName: this.firstName,
        lastName: this.lastName,
        jobTitle: this.jobTitle,
        email: this.email,
        phone: this.phone,
        phonePrefix: { id: this.phonePrefix }
      }
      this.isSubmitting = true
      await this.$store.dispatch('UsersStore/updateUser', updatedUser)
      const userTraits = {
        email: this.email,
        name: updatedUser.firstName,
        user_id: this.loggedUserId
      }
      this.$v.$reset()
      segmentIdentify(this.loggedUserId, userTraits)
      this.userAvatar = null
      await this.$store.dispatch('LoginStore/refreshToken')
      this.isSubmitting = false
    },
    _initialize () {
      if (this.user) {
        this.firstName = this.user ? this.user.firstName : ''
        this.lastName = this.user ? this.user.lastName : ''
        this.email = this.user ? this.user.email : ''
        this.phonePrefix = this.user && this.user.phonePrefix ? this.user.phonePrefix.id : ''
        this.phone = this.user ? this.user.phone : ''
        this.jobTitle = this.user ? this.user.jobTitle : ''
        this.profilePictureId = this.user && this.user.profilePicture ? this.user.profilePicture.id : 0
        this.fakePasscode = this.user && this.user.passCodeCreated ? '****' : ''
      }
    },

    setPhonePrefix (event) {
      this.phonePrefix = event
    },
    async setAvatar (event) {
      this.userAvatar = event
      if (this.userAvatar) await this.$store.dispatch('UsersStore/setUserPictureProfile', this.userAvatar)
    },
    touchPhoneFields () {
      this.$v.phone.$touch()
      this.$v.phonePrefix.$touch()
    },
    showResetPasswordModal () {
      this.$emit('showResetPasswordModal', true)
    },
    showSetPasscodeModal () {
      this.$emit('showSetPasscodeModal', true)
    },
    showForgotPasscodeModal () {
      this.showConfirmModalFlag = true
    },
    fetchConfig () {
      if (this.phonePrefixList.length === 0) {
        this.$store.dispatch('ConfigStore/fetchPublicConfig')
      }
    }
  },

  computed: {
    isDisabled () {
      return this.$store.getters['LoginStore/isAdmin']
    },
    user () {
      return this.$store.getters['UsersStore/userLogged']
    },
    fullUserName () {
      return this.user && this.user.firstName && this.user.lastName ? `${this.user.firstName} ${this.user.lastName}` : ''
    },
    loggedUserId () {
      return this.$store.getters['LoginStore/loggedUserId'] ? this.$store.getters['LoginStore/loggedUserId'] : {}
    },
    phonePrefixList () {
      return this.$store.getters['ConfigStore/publicConfig'].countries || []
    },
    hasPrefixOrPhoneErrors () {
      return this.$v.phone.$error || this.$v.phonePrefix.$error
    },
    canBeSubmitted () {
      return !this.$v.$invalid && this.$v.$anyDirty
    },
    hasCreatedPasscode () {
      return this.user ? this.user.passCodeCreated : false
    },
    userHasCards () {
      return this.user?.userCardsType === 'USER_CARDS_ALWAYS'
    }
  },
  created () {
    this.isCallingUsers = true
    if (this.phonePrefixList.length === 0) {
      this.$store.dispatch('ConfigStore/fetchPublicConfig')
    }
    if (this.user) {
      this._initialize()
    }
    this.isCallingUsers = false
  },
  mounted () {
    segmentTrack('User profile viewed')
  },
  watch: {
    hasCreatedPasscode: function (newV, oldV) {
      if (newV) {
        this.fakePasscode = '****'
      }
    },
    user: function (newV, oldV) {
      this._initialize()
    }
  },
  validations: {
    firstName: { required },
    lastName: { required },
    email: { required },
    phonePrefix: { required },
    phone: { required },
    jobTitle: {}
  }
}
</script>
<style scoped src="@/assets/styles/vue-multiselect-phone.css"></style>
<style lang="scss" scoped>
.forgot-passcode-tag {
  font-size: 0.8rem;
  color: var(--blue-action-1-active);
  text-decoration: underline !important;
  @media screen and (max-width: 576px) {
    justify-content: flex-start !important;
  }
}

.reset-secret-button {
  border: none;
  background: transparent;
  position: absolute;
  right: 10px;
  font-size: 0.8rem;
  top: 14px;
  color: var(--blue-action-1-active);
}

.submit-button {
  margin-top: 10px;
  width: 120px;
  justify-content: center;
  @media screen and (max-width: 576px) {
    width: 100%;
    margin-top: 20px;
  }
}
.buffer {
  @media screen and (max-width: 576px) {
    padding: 25px;
  }
}
</style>
